import React, { useEffect, useState } from "react";

const TARGET = new Date("2026-08-12T16:00:00+01:00").getTime();

function pad(n) { return String(n).padStart(2, "0"); }

function useCountdown(target) {
  const compute = () => {
    const diff = Math.max(0, target - Date.now());
    const days = Math.floor(diff / 86400000);
    const hours = Math.floor((diff / 3600000) % 24);
    const minutes = Math.floor((diff / 60000) % 60);
    const seconds = Math.floor((diff / 1000) % 60);
    return { days, hours, minutes, seconds };
  };
  const [t, setT] = useState(compute());
  useEffect(() => {
    const id = setInterval(() => setT(compute()), 1000);
    return () => clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return t;
}

function Unit({ value, label, testid }) {
  return (
    <div
      data-testid={testid}
      className="flex flex-col items-center justify-center bg-cream border border-[#C9A961]/40 rounded-sm px-3 py-3 md:px-5 md:py-5 shadow-[0_18px_40px_-20px_rgba(10,61,46,0.35)] min-w-[68px] md:min-w-[92px]"
    >
      <span className="font-serif-display text-emerald-deep text-3xl md:text-5xl font-light leading-none">
        {pad(value)}
      </span>
      <span className="mt-2 text-gold tracking-[0.3em] text-[9px] md:text-[10px]">
        {label}
      </span>
    </div>
  );
}

export default function Countdown() {
  const { days, hours, minutes, seconds } = useCountdown(TARGET);
  return (
    <section
      id="countdown"
      data-testid="countdown-section"
      className="section-pad"
    >
      <div className="max-w-5xl mx-auto text-center">
        <p className="gold-rule mb-6">Le grand jour approche</p>
        <h2 className="font-serif-display text-emerald-deep text-4xl md:text-5xl">
          Compte à rebours
        </h2>
        <p className="font-serif-display italic text-emerald/80 mt-3">
          Du 12 au 15 Août 2026 · Bitam, Gabon
        </p>

        <div className="mt-12 flex items-center justify-center gap-3 md:gap-6 flex-wrap">
          <Unit value={days} label="JOURS" testid="cd-days" />
          <span className="text-gold text-3xl">·</span>
          <Unit value={hours} label="HEURES" testid="cd-hours" />
          <span className="text-gold text-3xl">·</span>
          <Unit value={minutes} label="MINUTES" testid="cd-minutes" />
          <span className="text-gold text-3xl">·</span>
          <Unit value={seconds} label="SECONDES" testid="cd-seconds" />
        </div>
      </div>
    </section>
  );
}
